export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function isValidPhoneNumber(phoneNumber: string | number): boolean {
  //begin with +255 and contains 12 digits
  const re = /^255\d{9}$/gm;
  return re.test(String(phoneNumber));
}

export function isValidDocumentURL(url: string): boolean {
  const re = /^[(https?:\/\/)|(www)][^\s\/$.?#].[^\s]*\.(pdf|docx)$/i;
  return re.test(String(url));
}
